function CollectionScript() {

  function initFilterFacetsSlider() {
    const sliderEl = document.querySelector('.filter_facets_slider');
    if (!sliderEl) return;

    // Destroy existing instance if any
    if (sliderEl.swiper) {
      sliderEl.swiper.destroy(true, true);
    }

    document.querySelectorAll('.filter_facets_slider').forEach(el => {
      if (!el.classList.contains('swiper-initialized')) {
        new Swiper(el, {
          loop: false,
          grabCursor: true,
          slidesPerView: 'auto',
          spaceBetween: 0,
          freeMode: true,
          watchOverflow: true,
          threshold: 5,

          // ← This is the key fix for trackpad horizontal scroll
          mousewheel: {
            forceToAxis: true,
            sensitivity: 1,
            releaseOnEdges: true,
          },

          breakpoints: {
            0: {
              freeMode: true,
              spaceBetween: 0,
            },
            750: {
              spaceBetween: 0,
            }
          }
        })
      }
    });
  }
  // Init on page load
  initFilterFacetsSlider();

  // Reinit after Shopify filter/facet updates DOM
  document.addEventListener('DOMContentLoaded', () => {
    // Watch for facet form updates (Shopify rerenders the section)
    const facetObserver = new MutationObserver(() => {
      initFilterFacetsSlider();
    });

    const facetContainer = document.querySelector('.facets-container, #main-collection-filters, [data-section-type="collection"]');
    if (facetContainer) {
      facetObserver.observe(facetContainer, {
        childList: true,
        subtree: true,
      });
    }
  });

  // default open sorting for mobile drawer
  document.addEventListener('DOMContentLoaded', () => {
    const sortingDetails = document.querySelectorAll('[id^="Sorting-"]');

    if(sortingDetails){
      sortingDetails.forEach((el) => {
        if (window.innerWidth < 750) {
          el.open = true;
        } else {
          el.open = false;
        }
      });
    }
  });

  if (window.innerWidth <= 749) {
    const toggle = document.querySelector('.facets-toggle');
    const productGrid = document.querySelector('.product-grid');

    // Your existing observer (UNCHANGED)
    if (toggle) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) {
            document.body.classList.add('fixed-filter');
          } else {
            document.body.classList.remove('fixed-filter');
          }
        },
        { threshold: 0 }
      );

      observer.observe(toggle);
    }

    // ✅ New logic for product-grid
    if (productGrid) {
      window.addEventListener('scroll', () => {
        const rect = productGrid.getBoundingClientRect();
        const halfScreen = window.innerHeight / 2;

        // ADD when top hits top
        if (rect.top <= 0 && rect.bottom > halfScreen) {
          document.body.classList.add('fixed-filter');
        }

        // REMOVE when bottom reaches half screen
        if (rect.bottom <= halfScreen) {
          document.body.classList.remove('fixed-filter');
        }
      });
    }
  }

}

CollectionScript();

document.addEventListener("CollectionScript:init", CollectionScript);